<template>
  <Layout>
  <b-container>
    <b-card>
        <h2
        >{{$t('message.Personal_info')}}
        </h2>
      <b-row>
        <b-col md="6" class="mt-5">
          <label>{{$t('message.First_name')}}</label>
          <b-form-input :placeholder="$t('message.First_name')" v-model="form.first_name"></b-form-input>
          <br>
          <label>{{$t('message.Last_name')}}</label>
          <b-form-input :placeholder="$t('message.Last_name')" v-model="form.last_name"></b-form-input>
          <br>
          <label>{{$t('message.Middle_name')}}</label>
          <b-form-input :placeholder="$t('message.Middle_name')" v-model="form.middle_name"></b-form-input>
          <br>
          <label>{{$t('message.Phone_number')}}</label>
          <b-form-input :placeholder="$t('message.Phone_number')" v-model="form.mobile"></b-form-input>
        </b-col>
        <b-col md="6" class="mt-5">
          <label>{{$t('message.PINFL')}}</label>
          <b-form-input :placeholder="$t('message.PINFL')" v-model="form.pinfl"></b-form-input>
          <br>
          <label>{{$t('message.Region')}}</label>
          <b-form-input :placeholder="$t('message.Region')" v-if="form.region" v-model="form.region.nameuz"></b-form-input>
          <br>
          <label>{{$t('message.Rayon')}}</label>
          <b-form-input :placeholder="$t('message.Rayon')" v-if="form.rayon" v-model="form.rayon.nameuz"></b-form-input>
          <br>
          <label>{{$t('message.Address')}}</label>
          <b-form-input :placeholder="$t('message.Address')" v-model="form.address"></b-form-input>
        </b-col>
      </b-row>
<!--      <h2 class="mt-5">Pedagogik va ish staji</h2>-->
<!--      <b-row>-->
<!--        <b-col md="6" class="mt-5">-->
<!--          <div class="mb-3">-->
<!--            <label>Obyektivka</label>-->
<!--            <input class="form-control" type="file">-->
<!--            <br>-->
<!--            <label>Pedagogik ish staji</label>-->
<!--            <b-form-input placeholder="Pedagogik Staj"></b-form-input>-->
<!--            <br>-->
<!--            <label>Rahbarlik ish staji</label>-->
<!--            <b-form-input placeholder="Rahbarlik ish staji"></b-form-input>-->
<!--          </div>-->
<!--        </b-col>-->
<!--        <b-col md="6" class="mt-5">-->
<!--          <label>Esdalik nishon</label>-->
<!--          <b-form-input placeholder="Esdalik nishon"></b-form-input>-->
<!--          <br>-->
<!--          <label>Toifa</label>-->
<!--          <b-form-input placeholder="Toifa"></b-form-input>-->
<!--          <br>-->
<!--          <label>Chet tilini bilish darajasi</label>-->
<!--          <input class="form-control" type="file">-->
<!--        </b-col>-->
<!--      </b-row>-->
    </b-card>
  </b-container>
    <b-container>
      <b-card>
        <b-table striped hover :items="items" :fields="fields" responsive>
          <template #cell(status)="{item}">
            <div class="cirleStatus" :class="item.status === 1 ? 'bg-warning' : 'bg-secondary'">

            </div>
          </template>
          <template #cell(created_at)="{item}">
            {{item.created_at | formatDate}}
          </template>
          <template #cell(action)="data">
            <b-button
                @click="handlePush(data.item)"
                variant="primary"
                v-if="data.item.test_status.status_name === 'new'"
                size="md">
              {{$t('message.Begin')}}
            </b-button>
            <span v-else>
              {{data.item.test_status.name}}
            </span>
          </template>
        </b-table>
      </b-card>
    </b-container>
  </Layout>
</template>

<script>

import Layout from "../../../layouts/main";
import {getTestPersonalInformation} from '../../../../api/sms'
import {getTestMobile} from "../../../../utils/auth";
import moment from "moment";

export default {
  name: "PersonalInformation",
  components:{
    Layout
  },
  filters:{
    formatDate(val) {
      return moment(val).format('DD-MM-YYYY')
    }
  },
  created() {
    this.fetchPersonalTestInformation()
  },
  methods:{
    fetchPersonalTestInformation() {
      let testMobileData = JSON.parse(getTestMobile())
      getTestPersonalInformation({token: testMobileData.token}).then(res => {
          // this.form = res.data.application.length ? res.data.application[0].vacancy : null;
          this.items = res.data.data;
          this.form = res.data.application;
      })
    },
    handlePush(item){
      if(item.status === 1)
      this.$router.push({name: 'testlanguage', params:{ testId:item.id}})
    }
  },
  data() {
    return {
      fields: [
        {
          key:'id',
          label:"id"
        },
        {
          key:'application.region.nameuz',
          label: this.$t('message.Region')
        },
        {
          key:"application.rayon.nameuz",
          label:this.$t('message.Rayon')
        },
        {
          key:"application.vacancy.position.name",
          label: this.$t('message.Positions')
        },
        {
          key:'created_at',
          label: this.$t('message.Date_of_application')
        },
        {
          key: "status",
          label: this.$t('message.Status')
        },
        {
          key:'action',
          label: this.$t('message.Action')
        }
      ],
      items: [],

      options: [
        { text: 'Boshlash', value: 'value' },
      ],
      tests:[],
      form: {
        first_name: '',
        last_name: '',
        middle_name: '',
        mobile: '',
        education_id:null,
        pinfl:'',
        region_id: null,
        rayon_id: null,
        address: '',
        language_level:'',
        objective: null,
        experience_id: null,
        work_experience_id:null,
        lidership_experience_id: null,
        memorative_badge: null,
        category_id: null,
        government_reward: null,
        network_reward: null,
        teacher_competition: null,
        other_reward: null,
        receive_sms_offer: false,
      },
    }
  }
}
</script>

<style scoped>
h2 {
  text-align: center;
  color: #4d63cf;
}
.cirleStatus{
  border-radius: 50%;
  width: 28px;
  height: 28px;
}
</style>
